import React from "react";

export const Image = ({ title, largeImage, smallImage, style, subtitle }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        <a href={largeImage} title={title} data-lightbox-gallery="gallery1">
          <div className="hover-text">
            <h4>{title}</h4>
            {subtitle && <h4>{subtitle}</h4>}
          </div>
          <img
            style={style}
            src={smallImage}
            className="img-responsive"
            alt={title}
          />
        </a>
      </div>
    </div>
  );
};
